import { Component, OnInit } from '@angular/core';

@Component({
   selector: 'app-multiselector',
   templateUrl: './multiselector.component.html',
   styleUrls: ['./multiselector.component.sass']
})
export class MultiselectorComponent implements OnInit {

   constructor() { }

   ngOnInit() {
   }

}
